import api from './';

export default {
  getProjectStatusTypes() {
    return api.post('ProjectStatusTypes/GetList', {}).then(response => response.data);
  },
};
